import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SmartphoneIcon } from 'lucide-react';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-16 md:py-24 bg-white" data-id="element-78">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-80">
          <div className="flex justify-center mb-8" data-id="element-81">
            <div className="bg-[#f97316]/10 p-6 rounded-full" data-id="element-82">
              <SmartphoneIcon className="w-12 h-12 text-[#f97316]" data-id="element-83" />
            </div>
          </div>

          <div className="prose prose-lg md:prose-xl max-w-none text-gray-700 leading-relaxed space-y-6" data-id="element-84">
            <p className="text-xl md:text-2xl font-medium text-[#1e3a8a]" data-id="element-85">
              Estás aquí porque tienes un gran proyecto, pero te falta lo más
              importante: la primera venta.
            </p>

            <p data-id="element-86">
              Esa entrada de dinero que te dice "esto sí funciona". Sé lo que se
              siente mirar el teléfono esperando una notificación de pago que
              nunca llega mientras el tiempo corre.
            </p>

            <p data-id="element-87">
              La mayoría de los cursos te dicen que crees contenido por meses
              antes de vender. Nosotros no tenemos ese tiempo.
            </p>

            <p className="text-xl font-semibold text-[#1e3a8a]" data-id="element-88">
              Tú necesitas ingresos ahora, y este sistema está diseñado para
              forzar esos resultados en las próximas 48 horas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}